import { render, staticRenderFns } from "./HlRequestNewManagementPeriodPage.vue?vue&type=template&id=638e8b57&scoped=true&"
import script from "./HlRequestNewManagementPeriodPage.vue?vue&type=script&lang=ts&"
export * from "./HlRequestNewManagementPeriodPage.vue?vue&type=script&lang=ts&"
import style0 from "./HlRequestNewManagementPeriodPage.vue?vue&type=style&index=0&id=638e8b57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e8b57",
  null
  
)

export default component.exports